import crypto from 'crypto-es';

const KEY_HASH = 'most_secured_key_on_planet';

export const encrypt = (msg: string): string =>
    crypto.AES.encrypt(msg, KEY_HASH).toString();

export const decrypt = (msg: string): string =>
    crypto.AES.decrypt(msg, KEY_HASH).toString(crypto.enc.Utf8);
